import axios from '@fs/zion-axios'
import { getSessionId } from '@fs/zion-session'

// We don't want to reload on 401 in this case
// const axiosInstance = axios.create()

const BASE_PERMISSIONS_PATH = '/service/dmc/permissions'

export default async function getAuthorizedPermissions(newPermissions = false) {
  // This request is done before the app is setup to intercept all the requests. Maybe we need to rethink the initial architecture
  // of our app so that we can get rid of this second lookup at REACT_APP_DMC_SERVER === 'localhost'
  // const path = BASE_PERMISSIONS_PATH
  // if (process?.env_backup?.REACT_APP_DMC_SERVER === 'localhost') {
  //   path = 'http://localhost:8080/permissions'
  // }

  const sessionId = getSessionId()
  if (sessionId) {
    const permissionsUrl = newPermissions ? `${BASE_PERMISSIONS_PATH}/new` : BASE_PERMISSIONS_PATH

    const response = await axios
      .get(permissionsUrl, { headers: { Authorization: `Bearer ${sessionId}` } })
      .catch((error) => {
        if (error.response && error.response.status && error.response.status === 401) {
          window.location.replace(`/auth/login?returnUrl=${encodeURIComponent(window.location)}`)
        } else {
          throw error
        }
      })
    if (response && response.data) {
      return response.data
    }
  } else {
    window.location.replace(`/auth/login?returnUrl=${encodeURIComponent(window.location)}`)
  }
  return []
}
